import { parseError } from "~/data/core/api";

export function ErrorFallback({ error }: { error: unknown }) {
  return (
    <div className="text-center p-6">
      <h2 className="font-semibold text-2xl">Houve um erro</h2>
      <p>
        {error instanceof Error
          ? parseError(error)
          : typeof error === "string"
          ? error
          : "Erro indeterminado"}
      </p>
    </div>
  );
}
